// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._j0XpPneb27WrKipj2ZQ {\n  color: white;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://./src/Loading.sass"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACD","sourcesContent":[".loading\n\tcolor: white\n\twidth: 100%\n\theight: 100%\n\ttext-align: center\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "_j0XpPneb27WrKipj2ZQ"
};
export default ___CSS_LOADER_EXPORT___;
